import { getSettingRetailerExclusivityAgreements } from "@faire/help-center-utils/settings/getSettingRetailerExclusivityAgreements";

import { SelfServeContext } from "../../types";

const SettingRetailerExclusivityVisibilityFn =
  (settingIsOn: boolean) => (_context: SelfServeContext) => {
    return Promise.resolve(
      getSettingRetailerExclusivityAgreements() === settingIsOn
    );
  };

export const SettingRetailerExclusivityIsOn =
  SettingRetailerExclusivityVisibilityFn(true);
